'use strict';

/* global L */

const _ = require('lodash');

/** @SiteSelectorController */
function SiteSelectorController ($scope, $rootScope, AnalyticsService, Utils, Flux, SiteSelectorActions, leafletData, $timeout, IdentityService, sbAuth, MetricsService) {
  const SiteSelectorStore = Flux.Store.get('SiteSelectorStore');
  const SiteStore = Flux.Store.get('SiteStore');
  const AnnotationStore = Flux.Store.get('AnnotationStore');

  const vm = this;
  let mapTimeout;

  // ## CONSTANTS ##
  vm.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  vm.loading = true;

  vm.isUserLoading = !$rootScope.allUserDataReady;

  // Directive behavior
  vm.visible = false;
  vm.position = 'center';

  vm.filterableSites = []; // array that contains an object with site.name and site.id for the filter booster to use
  vm.availableSites = {}; // internal sites indexed by id
  vm.filteredSitesList = []; // array with the filtered site list - plain
  vm.filteredByProject = {}; //sites grouped by project so it can be displayed like that on the list
  vm.searchTerm = null; // initial search term, so we can trigger a change that the booster can detect, and render the list
  vm.siteListCount = 50; // how many sites should we show?

  //data for internal map booster
  vm.currentSitePreviewMap = {
    id: null,
    center: null,
    defaults: null,
    events: null,
    layers: {
      baseLayers: null,
      layers: null
    }
  };

  /**
   * Get when the SiteSelectorStore changes, and create new filterable list, and triggers the update on the ui
   */
  vm._handleStoreChange = () => {
    vm.isUserLoading = !$rootScope.allUserDataReady;
    vm.visible = SiteSelectorStore.get('dialogVisibility');

    //do not act over the hidden map
    if (vm.visible === false) {
      return;
    }

    const selectedSiteId = SiteSelectorStore.get('selectedSiteId') || SiteStore.get('current').id;

    // Build id indexed list and the filterable list
    const SiteSelectorAvailableSites = SiteSelectorStore.get('availableSites');

    vm.filterableSites = _.sortBy(SiteSelectorAvailableSites, (site) => {_.trim(site.name);});

    _.forEach(SiteSelectorAvailableSites, (site) => {
      site.selected = (selectedSiteId === site.id);
      vm.availableSites[site.id] = site;
    });

    vm.currentSitePreviewMap = SiteSelectorStore.get('currentSitePreviewMap');

    if (vm.searchTerm === null) {
      vm.searchTerm = ''; //trigger first change for ui update
    }

    mapTimeout = $timeout(() => { //because angular, thats why!
      leafletData.getMap('site-selector-map')
      .then((map) => {
        let bounds = vm.availableSites[selectedSiteId].location.bounds;
        const southWest = L.latLng(bounds.bottom, bounds.left);
        const northEast = L.latLng(bounds.top, bounds.right);
        bounds = L.latLngBounds(southWest, northEast);

        map.invalidateSize();
        map.fitBounds(bounds);
        map.invalidateSize();
      });
    }, 0, true);
  };

  vm.handleMapStoreLoad = () => {
    vm.loading = false;
  };

  vm.getResourceProxyAuth = () => {
    const resourceProxyUri = IdentityService.getResourceProxyUri();

    return sbAuth.getToken().then((token) => {
      return {
        resourceProxyUri,
        token
      };
    });
  };

  // Handlers //////////////////////////////////////////////////////////////////
  /**
   * Emit the Flux.Action matching the selected site on the list (called by the directive)
   */
  vm.handleSiteListItemClick = (data) => {
    if (SiteSelectorStore.get('selectedSiteId') !== data.id) {
      vm.loading = true;
    }

    vm.filterableSites = _.map(vm.filterableSites, (site) => {
      site.selected = (data.id === site.id);

      return site;
    });

    SiteSelectorActions.SitePreviewSelected.dispatch({
      site: data
    });
  };

  /**
   * Emit the Flux.Action matching the hide modal intent, and resets the filter
   */
  vm.hideModal = () => {
    vm.searchTerm = ''; // clean filter input on show
    vm.siteListCount = 50;
    vm.filteredSitesList = _.compact(vm.filterableSites).slice(0, vm.siteListCount);
    SiteSelectorActions.HideSiteSelector.dispatch();
  };

  vm._getSelectedSiteParams = () => {
    const siteMap = vm.currentSitePreviewMap;
    const params = {
      siteId: siteMap.id
    };

    if (siteMap.datacaptures && siteMap.datacaptures.length > 0) {
      params.defaultDataCapture = siteMap.datacaptures[0];
    }

    AnalyticsService.track('[CORE] View Map', 'Change Map View', {
      siteId: siteMap.id,
      siteName: vm.availableSites[siteMap.id].name
    });

    return params;
  };

  /**
   * Emit the Flux.Action matching the selected site by the SELECT button
   */
  vm.selectSite = () => {
    if (vm.currentSitePreviewMap.id === SiteStore.get('current').id) {
      // the user is trying to load the same site
      console.info('No same-site loading');
      vm.hideModal();
      return;
    }

    MetricsService.track('datacaptureReady', 'siteSelected', {
      forceNewFlow: true
    });

    if (AnnotationStore.get('active') && AnnotationStore.activeAnnotationChanged()) {
      $rootScope.$broadcast('dialog:siteSelector:promptDiscardActiveAnnotation');
    }
    else {
      SiteSelectorActions.SiteSelected.dispatch(vm._getSelectedSiteParams());
      vm.hideModal();
    }
  };

  /**
   * When the filtered list changes (the booster updates), updates the list of results
   */
  vm._handleFiltered = () => {
    vm.filteredSitesList = vm.siteListCount ? _.compact(vm.filtered).slice(0, vm.siteListCount): _.compact(vm.filtered);
  };

  vm.showMoreSites = () => {
    vm.siteListCount = vm.siteListCount + 100;
    vm._handleFiltered();
  };

  /*
   * Event Listeners
   */
  SiteSelectorStore.on(SiteSelectorStore.Events.Changed, vm._handleStoreChange.bind(vm), $scope);
  SiteStore.on(SiteStore.Events.Changed, vm._handleStoreChange.bind(vm), $scope);

  const deregisterDiscardActiveAnnotationListener = $scope.$on('dialog:siteSelector:confirmDiscardActiveAnnotation', () => {
    SiteSelectorActions.SiteSelected.dispatch(vm._getSelectedSiteParams());
    vm.hideModal();
  });

  const deregisterSitesFilteredListener = $scope.$watch('siteSelectorCtrl.filtered', vm._handleFiltered.bind(vm));

  const deregisterMapLoadedListener = $rootScope.$on('MAP_LOADED', _.debounce(this.handleMapStoreLoad.bind(this), 1000));

  $scope.$on('$destroy', () => {
    if (mapTimeout) {
      $timeout.cancel(mapTimeout);
    }

    deregisterDiscardActiveAnnotationListener();
    deregisterSitesFilteredListener();
    deregisterMapLoadedListener();
  });
}

SiteSelectorController.$inject = ['$scope', '$rootScope', 'AnalyticsService', 'Utils', 'sbFlux', 'SiteSelectorActions', 'leafletData', '$timeout', 'IdentityService', 'sbAuth', 'MetricsService'];

module.exports = SiteSelectorController;



// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/SiteSelectorController.js